import gsap from 'gsap';
import EventDispatcher from './EventDispatcher';
import Global from './Global';
import jQuery from 'jquery';
const $ = jQuery;
export default class Selection {
  constructor(scene, camera, renderer) {
    this.scene = scene;
    this.camera = camera;
    this.renderer = renderer;

    document
      .querySelector('#relocate2')
      .addEventListener('click', this.relocateSelection.bind(this));
    document
      .querySelector('.selection_ui #selectionNext')
      .addEventListener('click', this.proceedToGame.bind(this));
  }

  init() {
    this.events = EventDispatcher.getObj();
    this.events.addEventListener('LOADER_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('GAME_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));

    this.canSelectSide = false;
    this.platformItems = [];
  }

  onEvents(data) {
    switch (data.message.event_type) {
      case 'show_screen':
        this.showSelection(data.message.data);
        break;
      case 'clear_3d':
        this.killAll();
        break;
      case 'load_complete':
        this.onReady();
        break;
      case 'select_team':
        this.onTeamSelected(data.message.data);
        break;
      case 'update_language':
        this.updateLanguage();
        break;
    }
  }

  updateLanguage() {
    if (this.titleMaterial) {
      const map = Global.assets.textures[`leaderboard2_${Global.lang}`].asset;
      map.encoding = THREE.sRGBEncoding;
      map.colorSpace = THREE.SRGBColorSpace;

      this.titleMaterial.map = map;
    }
    if (this.chocolateLabel) {
      const chocolateMap =
        Global.assets.textures[`chocolate_label_${Global.lang}`].asset; // .clone()
      chocolateMap.encoding = THREE.sRGBEncoding;
      chocolateMap.colorSpace = THREE.SRGBColorSpace;
      this.chocolateLabel.material.map = chocolateMap;
      const hazelnutMap =
        Global.assets.textures[`hazelnut_label_${Global.lang}`].asset; // .clone()
      hazelnutMap.encoding = THREE.sRGBEncoding;
      hazelnutMap.colorSpace = THREE.SRGBColorSpace;
      this.hazelnutLabel.material.map = hazelnutMap;
    }
  }

  relocateSelection() {
    if (this.selectionGroup) {
      this.camera.updateMatrixWorld(true);

      const cameraPosition = new THREE.Vector3();
      const cameraDirection = new THREE.Vector3();

      this.camera.getWorldPosition(cameraPosition);
      this.camera.getWorldDirection(cameraDirection);

      // Project camera direction onto horizontal plane (XZ)
      const dirY = cameraDirection.y;
      cameraDirection.y = 0; // Math.min(1, Math.max(0, 0.5))
      cameraDirection.normalize();

      // Set fixed eye-level height (you can adjust this based on actual height)
      const eyeLevelY = Math.min(2, Math.max(-2, dirY));
      cameraPosition.y = eyeLevelY;

      const newPosition = cameraPosition
        .clone()
        .add(cameraDirection.multiplyScalar(0.1)); // 0.5 meters in front of the camera

      this.selectionGroup.position.copy(newPosition);

      // Make it face the camera (but keep it upright)
      // this.leaderboardGroup.lookAt(cameraPosition)
      this.selectionGroup.lookAt(
        new THREE.Vector3(cameraPosition.x, eyeLevelY, cameraPosition.z)
      );
    }
  }

  addLight(cookie) {
    cookie.traverse((child) => {
      if (!child.material) return;
      const { map } = child.material;
      child.material.envMap = this.environmentMap;
      map.encoding = THREE.sRGBEncoding;
      map.colorSpace = THREE.SRGBColorSpace;
      child.material.metalness = 0.1;
      child.material.roughness = 0.45;
      child.material.envMapIntensity = 2.5;
    });
  }

  onReady() {
    this.environmentMap = Global.assets.cubemap['0'].asset;
    this.hazelnut = Global.assets.glbs.hazelnut.asset.scene.clone();
    this.chocolate = Global.assets.glbs.chocolate.asset.scene.clone();
    this.addLight(this.hazelnut);
    this.addLight(this.chocolate);
  }

  showSelection(data) {
    if (data.screenKey != 'show_selection') return false;

    this.activateSelection();
  }

  killAll() {
    if (this.selectionGroup) {
      // console.log('Selection :: KillAll')
      document.querySelector('.selection_ui').classList.remove('active');
      // Traverse and dispose all meshes inside the group
      this.selectionGroup.traverse((child) => {
        if (child.isMesh) {
          child.geometry?.dispose();
          child.material?.dispose();
        }
      });

      // Remove the group from the scene and clear the reference
      this.scene.remove(this.selectionGroup);
      this.selectionGroup = null;
    }

    // Optionally reset stack counts if needed
    this.hazelStackCount = 0;
    this.chocoStackCount = 0;
  }

  proceedToGame() {
    if (Global.selectedFlavour == null) return false;

    Global.clickUpdater('selectFlavourNext_btn');
    Global.events.dispatchEvent({
      type: 'GAMESCENE_EVENTS',
      message: {
        event_type: 'clear_3d',
        data: {},
      },
    });
    Global.gameTry += 1;
    localStorage.setItem('gameTry', Global.gameTry);
    Global.serverObj.send(
      `${Global.BASE_URL}webservice.php`,
      (response) => {
        const data = JSON.parse(response);

        if (data.code == 200) {
          $('.selectFlavourNext_btn').css('opacity', '0.5');
          this.events.dispatchEvent({
            type: 'LOADER_EVENTS',
            message: {
              event_type: 'switch_page',
              data: {
                screenKey: 'GameInst',
              },
            },
          });
        } else if (data.code == 400) {
          Global.gameTry -= 1;
          localStorage.setItem('gameTry', Global.gameTry);
        }
      },
      null,
      {
        flavour: Global.selectedFlavour,
        gameTry: Global.gameTry,
        uniqID: Global.U_ID,
        playerMode: Global.isMultiplayer ? 'multiplayer' : 'singleplayer',
        saveType: 'saveFlavour',
      },
      'POST',
      null,
      false
    );
  }

  onTeamSelected(data) {
    if (!this.canSelectSide) return false;

    document.querySelector('#selectionNext').classList.add('active');
    Global.collectableType = data.teamKey;
    Global.selectedFlavour = data.teamKey;
    this.tick.position.x =
      this[`${Global.collectableType}Mesh`].position.x +
      (data.teamKey == 'chocolate' ? -0.15 : 0.15);
    this.tick.visible = true;
    gsap.killTweensOf(this[`${Global.collectableType}Mesh`].rotation);
    this[`${Global.collectableType}Mesh`].rotation.y = Math.PI * 2.2;
    gsap.to(this[`${Global.collectableType}Mesh`].rotation, {
      y: `${Math.PI * 4.2}`,
      duration: 2,
      delay: 0,
      ease: 'elastic.out(1,0.5)',
      onComplete: this.addSubtleRotation.bind(this, Global.collectableType),
    });
  }

  addSubtleRotation(cookieKey) {
    gsap.to(this[`${cookieKey}Mesh`].rotation, {
      y: `+=${
        Math.PI *
        0.035 *
        2 *
        (Math.random() < 0.5 ? 1 : -1) *
        Math.max(0.5, Math.random())
      }`,
      duration: 2,
      delay: 0,
      yoyo: true,
      delay: Math.random(),
      ease: 'cubic.inOut',
      repeat: -1,
    });
  }

  activateSelection() {
    document.querySelector('#selectionNext').classList.remove('active');
    Global.selectedFlavour = null;
    this.canSelectSide = false;
    const offset = 1.0;
    this.selectionGroup = new THREE.Group();
    this.selectionGroup.userData.itemType = 'leader_group';
    this.scene.add(this.selectionGroup);

    this.showCookie('chocolate', offset);
    this.showCookie('hazelnut', offset);
    const titlePadd = Math.max(this.hazelStackCount, this.chocoStackCount) + 4;
    const map = Global.assets.textures[`leaderboard2_${Global.lang}`].asset;
    map.encoding = THREE.sRGBEncoding;
    map.colorSpace = THREE.SRGBColorSpace;
    this.titleGeometry = new THREE.PlaneGeometry(0.4 * 3.13, 0.4, 1, 1);

    const tickMap = Global.assets.textures.Tick.asset;
    tickMap.encoding = THREE.sRGBEncoding;
    tickMap.colorSpace = THREE.SRGBColorSpace;
    this.tickGeo = new THREE.PlaneGeometry(0.2, 0.2, 1, 1);

    this.titleMaterial = new THREE.MeshStandardMaterial({
      map,
      transparent: true,
      opacity: 1,
      roughness: 1.0,
      metalness: 0.0,
      envMap: this.environmentMap,
      envMapIntensity: 4.5,
      // depthTest: false,
    });
    this.tickMaterial = new THREE.MeshStandardMaterial({
      map: tickMap,
      transparent: true,
      roughness: 1.0,
      metalness: 0.0,
      envMap: this.environmentMap,
      envMapIntensity: 4.5,
      // depthTest: false,
    });

    this.title = new THREE.Mesh(this.titleGeometry, this.titleMaterial);
    this.selectionGroup.add(this.title);
    this.title.position.set(0, 0.08 + 0.15, -3.75 + 1 * 0.5);
    this.title.scale.set(0, 0, 0);

    this.tick = new THREE.Mesh(this.tickGeo, this.tickMaterial);
    this.tick.visible = false;

    this.selectionGroup.add(this.tick);
    this.tick.position.set(0.5, -0.6 + 0.15, -3.0 + 1 * 0.5);
    // this.tick.scale.set(0, 0, 0);

    gsap.to(this.title.scale, {
      x: 1.5,
      y: 1.5,
      z: 1.5,
      duration: 1,
      delay: 1,
      ease: 'elastic.out(1,0.5)',
      onComplete: function () {
        this.canSelectSide = true;
      }.bind(this),
    });
    this.relocateSelection();
    document.querySelector('.selection_ui').classList.add('active');
  }

  showCookie(cookieKey, offset) {
    this[`${cookieKey}Mesh`] = this[cookieKey].clone();

    this.addLight(this[`${cookieKey}Mesh`]);
    this.selectionGroup.add(this[`${cookieKey}Mesh`]);

    const map =
      Global.assets.textures[`${cookieKey}_label_${Global.lang}`].asset; // .clone()
    map.encoding = THREE.sRGBEncoding;
    map.colorSpace = THREE.SRGBColorSpace;

    if (!this.labelGeometry) {
      this.labelGeometry = new THREE.PlaneGeometry(0.4 * 1.86, 0.4, 1, 1);
    }

    this[`${cookieKey}Mesh`].userData.itemType = 'team_select_cookie';
    this[`${cookieKey}Mesh`].userData.teamKey = cookieKey;
    this.cookielabel = new THREE.MeshStandardMaterial({
      map,
      transparent: true,
      opacity: 0,
      roughness: 1.0,
      metalness: 0.0,
      envMap: this.environmentMap,
      envMapIntensity: 4.5,
      // depthTest: false,
    });

    this[`${cookieKey}Label`] = new THREE.Mesh(
      this.labelGeometry,
      this.cookielabel
    );
    this.selectionGroup.add(this[`${cookieKey}Label`]);

    if (cookieKey == 'chocolate') {
      this[`${cookieKey}Mesh`].position.set(0.5, -1.25 + 0.15, -3.75 + 1 * 0.5);
      this[`${cookieKey}Label`].position.set(
        0.9,
        -1.25 + 0.5 + 0.15,
        -3.75 + 0.3 + 1 * 0.5
      );
    } else {
      this[`${cookieKey}Mesh`].position.set(
        -0.5,
        -1.25 + 0.15,
        -3.75 + 1 * 0.5
      );
      this[`${cookieKey}Label`].position.set(
        -0.9,
        -1.25 + 0.5 + 0.15,
        -3.75 + 0.3 + 1 * 0.5
      );
    }

    this[`${cookieKey}Mesh`].scale.set(0, 0, 0);

    const labelObj = {
      value: 0,
    };
    gsap.to(labelObj, {
      value: 1,
      duration: 0.75,
      delay: 1,
      onUpdate: function (cookielabel, labelObj) {
        cookielabel.opacity = labelObj.value;
      }.bind(this, this.cookielabel, labelObj),
      //   ease: 'elastic.out(1,0.5)',
    });
    gsap.to(this[`${cookieKey}Mesh`].scale, {
      x: 0.45,
      y: 0.45,
      z: 0.45,
      duration: 2,
      delay: 0,
      ease: 'elastic.out(1,0.5)',
    });
    gsap.to(this[`${cookieKey}Mesh`].rotation, {
      y: Math.PI * 2.2,
      duration: 2,
      delay: 0,
      ease: 'elastic.out(1,0.5)',
      onComplete: this.addSubtleRotation.bind(this, cookieKey),
    });
  }
}
